module.exports = __webpack_public_path__ + "img/m-switch-version.5822dd69.png";